import React, { useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { fetchAllClients, selectClients, selectClientsLoadingStatus } from 'features/clients/clientsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingStatus } from 'GeminiViewerComponent/helpers/AsyncStatus';
import {
    clearEditConfigValues,
    selectConfigValuesSelectedClientId,
    setSelectedClientId,
} from 'features/configValues/configValuesSlice';
import { setIsDirty } from 'features/common/formSlice';

export const ClientSelect = () => {
    const clients = useSelector(selectClients);
    const clientsLoadingStatus = useSelector(selectClientsLoadingStatus);
    const dispatch = useDispatch();

    const selectedClientId = useSelector(selectConfigValuesSelectedClientId);

    useEffect(() => {
        const fetchClients = async () => {
            dispatch(fetchAllClients());
        };
        if (clientsLoadingStatus == LoadingStatus.Idle) {
            fetchClients();
        }
    }, [clientsLoadingStatus, dispatch]);

    const clientsWithGlobal = [{ client_id: 0, display_name: '==GLOBAL==' }, ...clients];

    let clientId = selectedClientId;

    // Prevent error if clients haven't been fetched yet
    if (clientsWithGlobal.find((c) => c.client_id == clientId) < 0) {
        clientId = 0;
    }

    return (
        <FormControl size="small">
            <InputLabel id="asset-select-label">Client Override</InputLabel>
            <Select
                size="small"
                labelId="client-select-label"
                id="client-select"
                label="Client Override"
                style={{ minWidth: '300px' }}
                value={clientId}
                onChange={(e) => {
                    dispatch(clearEditConfigValues());
                    dispatch(setIsDirty(false));
                    dispatch(setSelectedClientId(e.target.value));
                }}
            >
                {clientsWithGlobal.map((client) => (
                    <MenuItem key={client.client_id} value={client.client_id}>
                        {client.display_name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
